import { IEvent } from "@quest/adapter-interface";
import { Bitmap, Container, dispatcher, ingenuity, ITween } from "@quest/base-core";
import { BlurBackgroundController, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { Linear } from "@quest/pixi-bridge";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class BlurBackgroundControllerGame extends BlurBackgroundController {
  // ... class implementation goes here
  protected investigationBlurBg: Bitmap;
    private blurBgFadeInDuration: number = 500;
  private blurBgFadeOutDuration: number = 300;

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_POP_UP_BLUR_BG, this.showPopUpBlurBg, this);
    dispatcher.on(eventDispatchers.HIDE_POP_UP_BLUR_BG, this.hideBlurBgWithFadeOutEffect, this);
  }

  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.SHOW_POP_UP_BLUR_BG, this.showPopUpBlurBg, this);
    dispatcher.off(eventDispatchers.HIDE_POP_UP_BLUR_BG, this.hideBlurBgWithFadeOutEffect, this);
  }

  // Add to show Big win, Fg Intro & Outro blur background
  private showPopUpBlurBg(evt: IEvent): void {
    const superWinBlurBg: Bitmap = this.view.getImageById("superWinBlurBg");
    const bigwinBlurImage: Bitmap = this.view.getImageById("bigwinBlurImage");
    const epicWinBlurBg: Bitmap = this.view.getImageById("epicWinBlurBg");
    const crazyWinBlurBg: Bitmap = this.view.getImageById("crazyWinBlurBg");
    const roomDesktopBlurBg: Bitmap = this.view.getImageById("roomDesktopBlurBg");
    const clueRewardBlurBg: Bitmap = this.view.getImageById("clueRewardBlurBg");
    const grandRewardBlurBg: Bitmap = this.view.getImageById("grandRewardBlurBg");
    switch (evt.data) {
      case gameConstants.SHOW_BIG_WIN_BLUR_BG:
        if (!bigwinBlurImage.visible) this.showBlurBgWithFadeInEffect(bigwinBlurImage, this.hideBgCallBack, []);
        break;
      case gameConstants.SHOW_SUPER_WIN_BLUR_BG:
        if (!superWinBlurBg.visible) this.showBlurBgWithFadeInEffect(superWinBlurBg, this.hideBgCallBack, [bigwinBlurImage]);
        break;
      case gameConstants.SHOW_EPIC_WIN_BLUR_BG:
        if (!epicWinBlurBg.visible) this.showBlurBgWithFadeInEffect(epicWinBlurBg, this.hideBgCallBack, [bigwinBlurImage, superWinBlurBg]);
        break;
      case gameConstants.SHOW_CRAZY_WIN_BLUR_BG:
        if (!crazyWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(crazyWinBlurBg, this.hideBgCallBack, [bigwinBlurImage, superWinBlurBg, epicWinBlurBg]);
        break;
      case gameConstants.SHOW_INVESTIGATION_BLUR_BG:
        if (!crazyWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(roomDesktopBlurBg, this.hideBgCallBack, [clueRewardBlurBg,grandRewardBlurBg]);
        break;
        case gameConstants.SHOW_CLUE_BLUR_BG:
        if (!crazyWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(clueRewardBlurBg, this.hideBgCallBack, [roomDesktopBlurBg]);
        break;
        case gameConstants.SHOW_GRAND_BLUR_BG:
        if (!crazyWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(grandRewardBlurBg, this.hideBgCallBack, [roomDesktopBlurBg, clueRewardBlurBg]);
        break;
    }
  }

   // Hide Blur Background with fade out effect
  private hideBlurBgWithFadeOutEffect(): void {
    const popUpBlurBgContainer: Container = this.view.getContainerByID("bigwinBlurContainer");
    const BlurBgFadeOutTween: ITween = ingenuity.currentGame.add
      .tween(popUpBlurBgContainer)
      .to({ alpha: 0 }, this.blurBgFadeOutDuration, Linear.None, true, 0, 0, false);
    BlurBgFadeOutTween.onComplete.addOnce(() => {
      BlurBgFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(BlurBgFadeOutTween);
      this.view.getImageById("bigwinBlurImage").visible = false;
      this.view.getImageById("superWinBlurBg").visible = false;
      this.view.getImageById("epicWinBlurBg").visible = false;
      this.view.getImageById("crazyWinBlurBg").visible = false;
      this.view.getImageById("roomDesktopBlurBg").visible = false;
      this.view.getImageById("clueRewardBlurBg").visible = false;
    this.view.getImageById("grandRewardBlurBg").visible = false;
    }, this);
  }

  /**
   * TO hide background on callbackground showBlurBgWithFadeInEffect method.
   * @param backgrounds
   * @returns
   */
  private hideBgCallBack(backgrounds: Bitmap[]): void {
    if (!backgrounds.length) return;
    backgrounds.forEach((background: Bitmap) => {
      background.visible = false;
    }, this);
  }

  
  // Show Blur Background with fade in effect
  private showBlurBgWithFadeInEffect(background: Bitmap, hideBgCallBack: Function, hideBGArray: Bitmap[]): void {
    const popUpBlurBgContainer: Container = this.view.getContainerByID("bigwinBlurContainer");
    popUpBlurBgContainer.alpha = 1;
    background.alpha = 0;
    background.visible = true;
    const BlurBgFadeInTween: ITween = ingenuity.currentGame.add
      .tween(background)
      .to({ alpha: 1 }, this.blurBgFadeInDuration, Linear.None, true, 0, 0, false);
    BlurBgFadeInTween.onComplete.addOnce(() => {
      BlurBgFadeInTween.stop();
      ingenuity.currentGame.tweens.remove(BlurBgFadeInTween);
      hideBgCallBack(hideBGArray);
    }, this);
  }


  protected hideBlurBG(evt: IEvent): void {
    let backgroudImage:any = null;
    if (evt.data.name === SlotConstantsBehavior.FULLSCREEN_BIGWIN_BLUR_BG) {
      backgroudImage = this.bigWinBG;
    } else if (evt.data.name === SlotConstantsBehavior.FREEGAME_OUTRO_BLUR_BG) {
      backgroudImage = this.freeGameOutroBG;
    } else if (evt.data.name === SlotConstantsBehavior.FREEGAME_INTRO_BLUR_BG) {
      backgroudImage = this.freeGameIntroBG;
    } else if (evt.data.name === gameConstants.INVESTIGATION_BG_SHOW) {
      backgroudImage = this.investigationBlurBg;
    }
    const hideBG = ingenuity.currentGame.add.tween(backgroudImage);
    hideBG.to({ alpha: SlotConstantsBehavior.ALPHA_0 }, evt.data.duration, Linear.None, true);
    hideBG.onComplete.addOnce(() => {
      hideBG.stop();
      backgroudImage.visible = false;
      ingenuity.currentGame.tweens.remove(hideBG);
    }, this);
  }
}
